import { ApiService } from './api';
import { ApiResponse } from '../types/auth';
import {
  NotificationsListResponse,
  NotificationsRequest,
  SendNotificationRequest
} from '../types/notifications';

export class NotificationsService {
  private apiService: ApiService;

  constructor() {
    this.apiService = ApiService.getInstance();
  }

  async getNotifications(request: NotificationsRequest): Promise<ApiResponse<NotificationsListResponse>> {
    try {
      const params = new URLSearchParams({
        page: request.page.toString(),
        pageSize: request.pageSize.toString(),
      });

      const response = await this.apiService.get<NotificationsListResponse>(
        `/admin/notifications?${params.toString()}`
      );

      return {
        data: response,
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to fetch notifications',
        success: false
      };
    }
  }

  async sendNotification(request: SendNotificationRequest): Promise<ApiResponse<void>> {
    try {
      await this.apiService.post<void>('/admin/notifications', request);

      return {
        success: true
      };
    } catch (error) {
      return {
        error: error instanceof Error ? error.message : 'Failed to send notification',
        success: false
      };
    }
  }
}

export const notificationsService = new NotificationsService();
